import { length } from '@turf/turf';

export const lengthSideWalk = (features) => {
  if (features !== undefined) {
    return length(features, { units: 'kilometers' });
  } else {
    return 0;
  }
};
